<div>
  <div class="summary-group">
    <div class="summary-title">{{'tasks.loan_detail' | translate | uppercase}}</div>
  </div>
  @if (loan) {
    <div class="overflow-y-auto overflow-x-hidden">
      <div class="field grid row">
        <div class="row">
          <div class="col">
          </div>
        </div>
        <div class="field grid row hrBottom">
          <div class="row">
            <div class="col">
              <span class="sub-title-label" translate>loans.amount<span>:</span></span>
            </div>
            <div class="col">
              <span class="value-label">{{formatNumber(loan.totalAmount) || 0}} {{loan.currency}}</span>
            </div>
          </div>
          <div class="row">
            <div class="col">
                        <a [attr.href]="isLoanApproval? '/user/customers/view/'+loan.customerSpecificOptions[0].customerId+'?agrNum='+loan.agreementNumber : null">
                                                    <span class="sub-title-label"
                                                          [pTooltip]="isLoanApproval ? 'Click and go to Loans page' : null"
                  tooltipStyleClass="tooltip-class" tooltipPosition="left"
                  translate>accounts.agreement_number<span>:</span></span>
                </a>
              </div>
              <div class="col">
                        <a [attr.href]="isLoanApproval? '/user/customers/view/'+loan.customerSpecificOptions[0].customerId+'?agrNum='+loan.agreementNumber : null">
                            <span class="value-label"
                                  [pTooltip]="isLoanApproval ? 'Click and go to Loans page' : null"
                    tooltipStyleClass="tooltip-class"
                  tooltipPosition="left">{{loan.agreementNumber}}</span>
                </a>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <span class="sub-title-label" translate>summary.agr_date<span>:</span></span>
              </div>
              <div class="col">
                <span class="value-label">{{loan.startDate}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <span class="sub-title-label" translate>common.status<span>:</span></span>
              </div>
              <div class="col">
                <span class="value-label">{{formatTextCapitalize(loan.status) || 'N/A'}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <span class="sub-title-label" translate>loans.product_name<span>:</span></span>
              </div>
              <div class="col">
                <span class="value-label">{{loan.name}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <span class="sub-title-label" translate>product.id<span>:</span></span>
              </div>
              <div class="col">
                <span class="value-label">{{loan.productId}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <span class="sub-title-label" translate>product.description<span>:</span></span>
              </div>
              <div class="col">
                <span class="value-label">{{loan.loanTemplateDescription}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <span class="sub-title-label" translate>tasks.group_id<span>:</span></span>
              </div>
              <div class="col">
                <span class="value-label">{{customerGroupId ||  'N/A'}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <a [attr.href]="isLoanApproval? '/user/customers/view/'+loan.customerSpecificOptions[0].customerId : null">
                  <span class="sub-title-label"
                    [pTooltip]="isLoanApproval ? 'Click and go to Customers page' : null"
                    tooltipStyleClass="tooltip-class" tooltipPosition="left"><span translate>customer_mngt.customer_id</span>:</span>
                  </a>
                </div>
                <div class="col">
                  <a [attr.href]="isLoanApproval? '/user/customers/view/'+loan.customerSpecificOptions[0].customerId : null">
                    <span class="value-label"
                      [pTooltip]="isLoanApproval ? 'Click and go to Customers page' : null"
                      tooltipStyleClass="tooltip-class"
                    tooltipPosition="left">{{loan.customerSpecificOptions[0].customerNumber}}</span>
                  </a>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <span class="sub-title-label" translate>summary.loan_customer_name<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{loan.customerSpecificOptions[0].customerFullName}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <span class="sub-title-label" translate>common.attached_files<span>:</span></span>
                </div>
                <div class="col">
                  @if (loan?.files && loan.files.length > 0) {
                    @for (file of loan.files; track file; let last = $last) {
                      <span class="value-label">
                        <span class="popup-item" (click)="downloadFile(file)">{{file.title || file.name}}</span>@if (!last) {<span>,&nbsp;</span>}
                      </span>
                    }
                  } @else {
                    <span class="value-label">—</span>
                  }
                </div>
              </div>
            </div>
          </div>
          <div class="field grid row">
            <div class="row">
              <div class="col">
                <span class="title-label">{{'collaterals.outstanding_amounts'| translate | uppercase}}</span>
              </div>
            </div>
            <div class="field grid row hrBottom">
              <div class="row">
                <div class="col">
                  <span class="sub-title-label" translate>loans.outstanding_amount<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{formatNumber(loan.outstandingSummary?.outstandingAmount) || 0}} {{loan.currency}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <span class="sub-title-label" translate>summary.calculated_interest<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{formatNumber(loan.outstandingSummary?.outstandingInterestAmount) || 0}} {{loan.currency}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <span class="sub-title-label" translate>loans.calculated_service_fee<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{formatNumber(loan.outstandingSummary?.outstandingServiceFeeAmount) || 0}} {{loan.currency}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <span class="sub-title-label" translate>summary.loans.outstanding_late_payment_fee<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{formatNumber(loan.outstandingSummary?.outstandingLateRepaymentFeeAmount) || 0}} {{loan.currency}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <span class="sub-title-label" translate>summary.loans.outstanding_interest_late_payment_fee<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{formatNumber(loan.outstandingSummary?.outstandingInterestLateRepaymentFeeAmount) || 0}} {{loan.currency}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <span class="sub-title-label" translate>summary.loans.service_fee_late_payment_outstanding_fee<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{formatNumber(loan.outstandingSummary?.outstandingServiceFeeLatePaymentFeeAmount) ||0}} {{loan.currency}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <span class="title-label">{{'summary.loans.loan_parameters' | translate | uppercase}}</span>
            </div>
            <div class="field grid row hrBottom">
              <div class="row">
                <div class="col">
                  <span class="sub-title-label" translate>common.period<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{loanPeriodCovertToString()}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <span class="sub-title-label" translate>summary.interest_rate<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{loan.interestRate}}%</span>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <span class="sub-title-label" translate>loans.agreement_date<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{loan.startDate}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <span class="sub-title-label" translate>loans.granting_date<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{loan.grantingDate || '—'}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <span class="sub-title-label" translate>loans.first_payment_date<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{loan.firstRepaymentDate}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <span class="sub-title-label" translate>loans.interest_calculate_opt<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{findInterestCalculationOptions(loan.interestCalculationOption)}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col padding-item">
                  <span class="sub-title-label" translate>loans.maturity_date<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{loan.maturityDate}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col padding-item">
                  <span class="sub-title-label" translate>loans.maturity_type<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{formatUppercaseText(loan.maturityType)}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col padding-item">
                  <span class="sub-title-label" translate>loans.auto_direct_debit_indicator<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{loan.autoDirectDebitIndicator ? "Yes" : "No"}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col padding-item">
                  <span class="sub-title-label" translate>loans.early_repayment<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{loan.earlyRepayment ? "Yes" : "No"}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col padding-item">
                  <span class="sub-title-label" translate>loans.early_repayment_fee<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{loan.earlyRepaymentFee ? "Yes" : "No"}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col padding-item">
                  <span class="sub-title-label" translate>loans.service_fee<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{getLoanServiceFeeAmount()}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <span class="sub-title-label" translate>loans.late_payment_fee_pricipal<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{getLatePaymentFeePrincipal()}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <span class="sub-title-label" translate>loans.late_payment_fee_interest<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{getLatePaymentFeeInterest()}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <span class="sub-title-label" translate>loans.late_payment_fee_service_fee<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{getLatePaymentFeeServicefee()}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col padding-item">
                  <span class="sub-title-label" translate>loans.upfront_fee<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{getUpfrontFee()}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col padding-item">
                  <span class="sub-title-label" translate>loans.upfront_service_fee<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{getUpfrontServiceFee()}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="field grid row">
            <div class="row">
              <div class="col">
                <span class="title-label">{{'risks.classification-provisioning' | translate | uppercase}}</span>
              </div>
            </div>
            <div class="field grid row hrBottom">
              <div class="row">
                <div class="col padding-item">
                  <span class="sub-title-label" translate>risks.risk-classification-code<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{loan.riskCategory || 'N/A'}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col padding-item">
                  <span class="sub-title-label" translate>loan-provision.amount<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{loan?.provisionAmount || 0}} {{loan.currency}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col padding-item">
                  <span class="sub-title-label" translate>loan-provision.percentage<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{loan.provisioningRate ? loan.provisioningRate + '%' : 'N/A'}}</span>
                </div>
              </div>
            </div>
          </div>
          @if (loan.linkedAccount) {
            <div class="field grid row">
              <div class="row">
                <div class="col">
                  <span class="title-label">{{'linked_accounts.title' | translate | uppercase}} </span>
                </div>
                <div class="field grid row hrBottom">
                  <div class="row">
                    <div class="col">
                      <span class="sub-title-label" translate>loans.account<span>:</span></span>
                    </div>
                    <div class="col pl-30">
                      <span class="value-label">{{loan.customerSpecificOptions?.[0]?.grantingAccountNumber || '—'}}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <span class="sub-title-label" translate>loans.correspond_acc<span>:</span></span>
                    </div>
                    <div class="col pl-30">
                      <span class="value-label">{{loan.customerSpecificOptions[0].correspondentAccountNumber || '—'}}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <span class="sub-title-label" translate>loans.interest_correspond_acc<span>:</span></span>
                    </div>
                    <div class="col pl-30">
                      <span class="value-label">{{loan.customerSpecificOptions[0].interestCorrespondentAccountNumber || '—'}}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <span class="sub-title-label" translate>accounts.interest_acc<span>:</span></span>
                    </div>
                    <div class="col pl-30">
                      <span class="value-label">{{loan.linkedAccount.interestAccountNumber || '—'}}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <span class="sub-title-label" translate>loans.interest_income_acc<span>:</span></span>
                    </div>
                    <div class="col pl-30">
                      <span class="value-label">{{loan.linkedAccount.interestIncomeAccountNumber || '—'}}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <span class="sub-title-label" translate>loans.interest_late_payment_fee_acc<span>:</span></span>
                    </div>
                    <div class="col pl-30">
                      <span class="value-label">{{loan.linkedAccount.interestLateRepaymentFeeAccountNumber || '—'}}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <span class="sub-title-label" translate>loans.interest_late_payment_fee_income_acc<span>:</span></span>
                    </div>
                    <div class="col pl-30">
                      <span class="value-label">{{loan.linkedAccount.interestLateRepaymentFeeIncomeAccountNumber || '—'}}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <span class="sub-title-label" translate>loans.service_fee_acc<span>:</span></span>
                    </div>
                    <div class="col pl-30">
                      <span class="value-label">{{loan.linkedAccount.serviceFeeAccountNumber || '—'}}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <span class="sub-title-label" translate>loans.service_fee_income_acc<span>:</span></span>
                    </div>
                    <div class="col pl-30">
                      <span class="value-label">{{loan.linkedAccount.serviceFeeIncomeAccountNumber || '—'}}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <span class="sub-title-label" translate>loans.service_late_payment_fee_acc<span>:</span></span>
                    </div>
                    <div class="col pl-30">
                      <span class="value-label">{{loan.linkedAccount.serviceFeeLatePaymentFeeAccountNumber || '—'}}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <span class="sub-title-label" translate>loans.service_late_payment_fee_income_acc<span>:</span></span>
                    </div>
                    <div class="col pl-30">
                      <span class="value-label">{{loan.linkedAccount.serviceFeeLatePaymentFeeIncomeAccountNumber || '—'}}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <span class="sub-title-label" translate>loans.late_payment_fee_acc<span>:</span></span>
                    </div>
                    <div class="col pl-30">
                      <span class="value-label">{{loan.linkedAccount.lateRepaymentFeeAccountNumber || '—' }}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <span class="sub-title-label"
                        translate>loans.late_payment_fee_income_acc<span>:</span></span>
                      </div>
                      <div class="col pl-30">
                        <span class="value-label">{{loan.linkedAccount.lateRepaymentFeeIncomeAccountNumber || '—'}}</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <span class="sub-title-label" translate>loans.early_fee_acc<span>:</span></span>
                      </div>
                      <div class="col pl-30">
                        <span class="value-label">{{loan.linkedAccount.earlyRepaymentFeeAccountNumber || '—'}}</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <span class="sub-title-label" translate>loans.early_fee_income_acc<span>:</span></span>
                      </div>
                      <div class="col pl-30">
                        <span class="value-label">{{loan.linkedAccount.earlyRepaymentFeeIncomeAccountNumber || '—'}}</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <span class="sub-title-label" translate>loans.upfront_fee_income_acc<span>:</span></span>
                      </div>
                      <div class="col pl-30">
                        <span class="value-label">{{loan.linkedAccount.upfrontFeeIncomeAccountNumber || '—'}}</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <span class="sub-title-label" translate>loans.upfront_service_fee_income_acc<span>:</span></span>
                      </div>
                      <div class="col pl-30">
                        <span class="value-label">{{loan.linkedAccount.serviceUpfrontFeeIncomeAccountNumber || '—'}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            @if (loan.notes?.length > 0) {
              <div class="field grid row">
                <div class="row">
                  <div class="col">
                    <span class="title-label">{{'common.notes' | translate | uppercase}}</span>
                  </div>
                  <div class="field grid row hrBottom">
                    @for (note of notesHierarchy; track note) {
                      <div class="row">
                        <div class="col">
                          <span class="sub-title-label">{{note.parent}}:</span>
                        </div>
                        <div class="col pl-30">
                          <span class="value-label"> {{note.child}}</span>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
            <div class="field grid row">
              <div class="row">
                <div class="col">
                  <div class="title-label">{{'common.add_info' | translate | uppercase}}</div>
                </div>
              </div>
              <div class="field grid row hrBottom">
                <div class="row">
                  <div class="col">
                    <span class="sub-title-label" translate>summary.loans.loan_description<span>:</span></span>
                  </div>
                  <div class="col">
                    <span class="value-label">{{loan.description || '—'}}</span>
                  </div>
                </div>
                @if (loan.closeDate) {
                  <div class="row">
                    <div class="col padding-item">
                      <span class="sub-title-label" translate>common.close_date<span>:</span></span>
                    </div>
                    <div class="col">
                      <span class="value-label">{{loan.closeDate}}</span>
                    </div>
                  </div>
                }
                <div class="row">
                  <div class="col padding-item">
                    <span class="sub-title-label" translate>common.branch<span>:</span></span>
                  </div>
                  <div class="col">
                    <span class="value-label">{{getBranchName(loan.branchId)}}</span>
                  </div>
                </div>
              </div>
            </div>
            @if (loan && loan.upfrontFeeChargingOp) {
              <div class="field grid row hrBottom">
                <div class="row">
                  <span class="sub-title-label">{{'loans.upfront_fee' | translate | uppercase}}</span>
                </div>
                <div class="row">
                  <div class="col">
                    <span class="sub-title-label" translate>orders.document_number<span>:</span></span>
                  </div>
                  <div class="col">
                    <span class="value-label">{{loan.upfrontFeeChargingOp.documentNumber}}</span>
                  </div>
                </div>
                @if (loan.upfrontFee) {
                  <div class="row">
                    <div class="col">
                      <span class="sub-title-label" translate>common.date<span>:</span></span>
                    </div>
                    <div class="col">
                      <span class="value-label">{{loan.upfrontFeeChargingOp.date}}</span>
                    </div>
                  </div>
                }
                <div class="row">
                  <div class="col">
                    <span class="sub-title-label" translate>common.amount<span>:</span></span>
                  </div>
                  <div class="col">
                    <span class="value-label">{{formatNumber(loan.upfrontFeeChargingOp.amount)}}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <span class="sub-title-label" translate>loans.upfront_fee_charge<span>:</span></span>
                  </div>
                  <div class="col">
                    <span class="value-label">{{loan.upfrontFeeChargingOp.chargingType}}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <span class="sub-title-label" translate>common.branch<span>:</span></span>
                  </div>
                  <div class="col">
                    <span class="value-label">{{getBranchNameFromCode(loan.upfrontFeeChargingOp.branchCode)}}</span>
                  </div>
                </div>
              </div>
            }
            @if (loan && loan.grantingOp) {
              <div class="field grid row hrBottom">
                <div class="row">
                  <span class="sub-title-label">{{'loans.granting' | translate | uppercase}}</span>
                </div>
                <div class="row">
                  <div class="col">
                    <span class="sub-title-label" translate>orders.document_number<span>:</span></span>
                  </div>
                  <div class="col">
                    <span class="value-label">{{loan.grantingOp.documentNumber}}</span>
                  </div>
                </div>
                @if (loan.grantingOp) {
                  <div class="row">
                    <div class="col">
                      <span class="sub-title-label" translate>common.date<span>:</span></span>
                    </div>
                    <div class="col">
                      <span class="value-label">{{loan.grantingOp.date}}</span>
                    </div>
                  </div>
                }
                <div class="row">
                  <div class="col">
                    <span class="sub-title-label" translate>common.amount<span>:</span></span>
                  </div>
                  <div class="col">
                    <span class="value-label">{{formatNumber(loan.grantingOp.amount)}}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <span class="sub-title-label" translate>loans.granting<span>:</span></span>
                  </div>
                  <div class="col">
                    <span class="value-label">{{loan.grantingOp.grantingType}}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <span class="sub-title-label" translate>common.branch<span>:</span></span>
                  </div>
                  <div class="col">
                    <span class="value-label">{{getBranchName(loan.grantingOp.branchId)}}</span>
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>